// extracted by mini-css-extract-plugin
export default {"loanRequest":"LoanRequest_loanRequest__nj4tF","loanRequest__text":"LoanRequest_loanRequest__text__vxtA6","loanRequest__total":"LoanRequest_loanRequest__total__GlNpL"};